export const openLoginSosialPopup = (url) => {
  //   const url = process.env.NEXT_PUBLIC_SITE_URL + "/login";
  const width = 600;
  const height = 800;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  const popup = window.open(
    url,
    "LoginPopup",
    `width=${width},height=${height},left=${left},top=${top}`
  );

  if (popup) {
    popup.focus();
  }
};
